/**
 * @flow
 */

import React from 'react'
import AriaModal from 'react-aria-modal'

import EnquireNowModal from '../EnquireNowModal'

import {
  DownloadButtonContainer,
  ButtonContainer,
  ButtonText
} from './styledComponents'

class EnquireNowButton extends React.Component<Props> {
  static defaultProps = {
    text: 'GET IN TOUCH'
  }
  state = {
    showModal: false
  }

  handleClick = () => {
    this.setState({
      showModal: true
    })
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      document.body.style.overflowY = 'hidden'
    }
  }

  closeModal = () => {
    this.setState({
      showModal: false
    })
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      document.body.style.overflowY = 'scroll'
    }
  }

  render() {
    const { text, className, id, glsLoaded, formData } = this.props
    const { showModal } = this.state

    return (
      <ButtonContainer>
        <DownloadButtonContainer
          className={className}
          onClick={this.handleClick}
          id={id}
        >
          <ButtonText>{text}</ButtonText>
        </DownloadButtonContainer>
        <AriaModal
          titleId="wc-fan-tour-enquire-now-modal"
          focusDialog
          onExit={this.closeModal}
          mounted={showModal}
        >
          <EnquireNowModal
            formData={formData}
            glsLoaded={glsLoaded}
            closeModal={this.closeModal}
          />
        </AriaModal>
      </ButtonContainer>
    )
  }
}

export default EnquireNowButton



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowButton/index.js